import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import postsReducer from './postsSlice';
import singlePostReducer from './singlePostSlice';
import notificationReducer from './notificationSlice';
// import profileStoryReducer from './profileStorySlice';
// import profileFeedReducer from './profileFeedSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    posts: postsReducer,
    notifications: notificationReducer,
    singlePost: singlePostReducer,
    // profileStory: profileStoryReducer,
    // profileFeed: profileFeedReducer,
  },
});

export default store;
